import Highlight from "../components/Highlight";
import Layout from "../components/Layout";

export default function Home() {
    return (
        <Layout>
            <Highlight />
        </Layout>
    )
}